import React from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Block from '../block';
import { getIsPreviewStatus } from '../../state/app';

const BlockMenuV2 = (node) => {
	return (
		<>
			<ul className="block-menu-v2">
				{
					node.links.map((link, i) => {
						return <li key={i} className={`block-menu-col${node.links.length > 1 && '-' + node.links.length}`}><Block block={link}></Block></li>
				   	})
				}
			</ul>
		</>
	)
};

function mapStateToProps(state) {
    return {
        isPreview: getIsPreviewStatus(state)
    };
}
BlockMenuV2.propTypes = {
    isPreview: PropTypes.bool,
}

const ContentfulBlockMenuV2 = connect(mapStateToProps)(BlockMenuV2);

export { ContentfulBlockMenuV2 }
